import { Trans } from '@lingui/react/macro';
import GitHubIcon from 'interface/icons/GitHubMarkSmall';
import Logo from 'interface/images/logo.svg?react';
import makeAnalyzerUrl from 'interface/makeAnalyzerUrl';
import { getPlayerName } from 'interface/selectors/url/report';
import Tooltip from 'interface/Tooltip';
import { useWaSelector } from 'interface/utils/useWaSelector';
import { HTMLAttributes, ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';

import './NavigationBar.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
}

const NavigationBar = ({ children, ...others }: Props) => {
  const { pathname } = useLocation();
  const playerName = getPlayerName(pathname);
  const report = useWaSelector((state) => state.navigation.report);
  const fight = useWaSelector((state) => state.navigation.fight);

  return (
    <nav className="global" {...others}>
      <div className="container">
        <div className="menu-item logo required">
          <Link to={makeAnalyzerUrl()}>
            <Logo />
          </Link>
        </div>
        {children && <div className="menu-item">{children}</div>}
        {report ? (
          <div className="menu-item report-title">
            <Link to={report.link}>{report.title}</Link>
          </div>
        ) : null}
        {report ? (
          <div className="menu-item">
            <Link to={report.link}>
              {fight ? (
                fight.title
              ) : (
                <Trans id="interface.layout.navigationBar.fightSelection">战斗选择</Trans>
              )}
            </Link>
          </div>
        ) : null}
        {report && (fight || playerName) && (
          <div className="menu-item">
            <Link to={fight?.link ?? report.link}>
              {playerName ?? (
                <Trans id="interface.layout.navigationBar.playerSelection">玩家选择</Trans>
              )}
            </Link>
          </div>
        )}
        <div className="spacer" />
        <Tooltip content="GitHub">
          <div className="menu-item optional">
            <a href="https://github.com/WoWAnalyzer/WoWAnalyzer">
              <GitHubIcon />
            </a>
          </div>
        </Tooltip>
      </div>
    </nav>
  );
};

export default NavigationBar;
